

/**
 * Link object:
 * - name: link text
 * - desc: description
 * - lib: FA icon library (only for brand icons)
 * - icon: FontAwesome ID
 * - url: link destination
 * - groups: [ art || design || tech || head ]
 */
export const links = [
  {
    name: 'Instagram',
    desc: '@cant_imagine_why - Updated somewhat regularly',
    lib: 'fab',
    icon: 'instagram',
    url: 'https://instagram.com/cant_imagine_why',
    groups: [ 'art', 'head' ]
  },
  {
    name: 'Facebook',
    desc: 'Personal profile',
    lib: 'fab',
    icon: 'facebook',
    url: 'https://facebook.com/acharliekelly',
    groups: [ 'art', 'head' ]
  },
  {
    name: 'GitHub',
    desc: 'Project repo for this website',
    lib: 'fab',
    icon: 'github',
    url: 'https://github.com/acharliekelly',
    groups: [ 'tech' ]
  },
  {
    name: 'Blog',
    desc: 'Can\'t Imagine How: My Adventures in Development',
    lib: 'fab',
    icon: 'blogger-b',
    url: 'https://cantimaginehow.blogspot.com/',
    groups: [ 'tech' ]
  },
  {
    name: 'Flickr',
    desc: 'Same artwork as here, but on a different site',
    lib: 'fab',
    icon: 'flickr',
    url: 'https://www.flickr.com/photos/acharliekelly/albums',
    groups: [ 'art' ]
  },
  {
    name: 'LinkedIn',
    desc: 'My professional profile',
    lib: 'fab',
    icon: 'linkedin',
    url: 'https://linkedin.com/in/acharliekelly',
    groups: [ 'tech' ]
  },
  {
    name: 'Portfolio',
    desc: 'My official development portfolio',
    icon: 'file-alt',
    url: 'https://acharliekelly.github.io',
    groups: [ 'tech' ]
  },
  {
    name: 'Email',
    desc: 'In case you want to contact me but are completely antisocial',
    icon: 'paper-plane',
    url: 'mailto:charlie@cantimaginewhy.com',
    groups: [ 'art', 'tech', 'head' ]
  },
  {
    name: 'Arifa Sayyid',
    desc: 'Design Consultant',
    lib: 'fab',
    icon: 'linkedin',
    url: 'https://linkedin.com/in/asayyid',
    groups: [ 'design' ]
  },
  {
    name: 'Nandita Vedantan',
    desc: 'Design Consultant',
    lib: 'fab',
    icon: 'linkedin',
    url: 'https://linkedin.com/in/nanditavedantan',
    groups: [ 'design' ]
  },
  {
    name: 'Julia Tooker',
    desc: 'Design Consultant',
    lib: 'fab',
    icon: 'linkedin',
    url: 'https://linkedin.com/in/julia-tooker',
    groups: [ 'design' ]
  }

];
